import { TechnicalIndicatorDto } from './dtos/technical-indicator.dto';
import { axiosCore } from './http-core-service';

/**
 * Récupération des indicateurs de données.
 * @param mandateId identifiant du mandat
 * @param key
 */
export const getTechnicalIndicators = async (mandateId: string, key: string): Promise<Array<TechnicalIndicatorDto>> => {
    const response = await axiosCore.get(`/api/indicators/mandate/${mandateId}?key=${key}`);
    return response.data;
};
